<template>
    <div>

        <div class="p-5">
            <h1 class="text-5xl text-slate-600 font-bold font-medium tracking-tight">Tools Home</h1>
        </div>

        <div class="m-5">
            <div class="m-5 flex mb-6 text-sm font-medium">
                <div class="mx-1">
                    <router-link :to="{ name: 'buttons' }" class="py-2 px-6 rounded-md bg-black text-white">Tailwind Button Explorer</router-link>
                </div>

                <div class="mx-1">
                    <router-link :to="{ name: 'ai' }" class="py-2 px-6 rounded-md bg-black text-white">AI</router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Tools Home',
    props: ['prop1', 'prop2'],
    data () {
        return {
            model: webase.model
        }
    },
    mounted () {
    },
    methods: {
        importantMethodHere () {
        }
    }
}
</script>
